import { render, staticRenderFns } from "./CommandEdit.vue?vue&type=template&id=39318cc2"
import script from "./CommandEdit.vue?vue&type=script&lang=js"
export * from "./CommandEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports